import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { OnboardingScreen } from './pages/OnboardingScreen';
import { pages } from './data/pages';
interface AppProps {
  /** Present the funnels-and-ads part as skippable for clients without an ads plan. */
  adsPartOptional?: boolean;
}
export function App({
  adsPartOptional = true
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="2rlowqhk2dx92">
      <Layout data-id="element-1" data-mp="2rit1j0zlpmob">
        <Routes data-id="element-2" data-mp="2riklx1c3g39f">
          <Route path="/" element={<Navigate to={`/${pages[0].slug}`} replace data-id="element-4" data-mp="2mmvl6uoc8gbj" />} data-id="element-3" data-mp="2mm2nej7cx15j" />
          <Route path="/:slug" element={<OnboardingScreen adsPartOptional={adsPartOptional} data-id="element-6" data-mp="31bi9vmzuukff" />} data-id="element-5" data-mp="31aqdwb2cikom" />
          <Route path="*" element={<Navigate to={`/${pages[0].slug}`} replace data-id="element-8" data-mp="2wj8fnurpiy7c" />} data-id="element-7" data-mp="2wjqgl4pbe0ll" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}